import { TokenExpired } from 'components/tokenExpired';
import { Unauthorized } from 'components/unauthorized';
import { useCanAccess } from 'hooks/useCanAccess';
import { AdminProviderDashboard } from 'pages/providerDashboard/AdminProviderDashboard';

export const AdminProviderDashboardRoute = () => {
  const { isAdmin, isExpired } = useCanAccess('provider-dashboard');

  return isExpired ? (
    <TokenExpired />
  ) : isAdmin ? (
    <AdminProviderDashboard />
  ) : (
    <Unauthorized />
  );
};
